import getTrainingAuthSelector from 'modules/training/modules/app-auth/selectors/get'
import { TRAINING_AUTH_KEY } from 'modules/training/modules/app-auth/constants'

const getPasswordTrainingAuthSelect = getTrainingAuthSelector(TRAINING_AUTH_KEY.PASSWORD)

export default getPasswordTrainingAuthSelect
